import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';

import { VALUE_CHANGES_INTERVAL } from '../../constants';

@Directive({
  selector: 'form[appFocusFirstInput]',
  standalone: false,
})
export class FocusFirstInputDirective implements AfterViewInit {
  @Input() focusDelay: number = VALUE_CHANGES_INTERVAL;

  constructor(private element: ElementRef) {
  }

  ngAfterViewInit(): void {
    const input = this.element.nativeElement.querySelector('input');
    if (input) {
      setTimeout(() => {
        input.focus();
      }, this.focusDelay);
    }
  }
}
